<template>
  <div style="height: 100%; width: 100%" class="d-flex justify-center">
    <transition name="fade" mode="out-in">
      <div
        v-if="!mode"
        key="1"
        style="
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <v-tooltip text="Add a link to your post" location="bottom">
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              @click="selectMode('link')"
              icon="mdi-link-variant"
              color="faded"
              variant="text"
            ></v-btn
          ></template>
        </v-tooltip>

        <v-tooltip
          text="Add an image, video or document to your post"
          location="bottom"
        >
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              @click="selectMode('image')"
              icon="mdi-multimedia"
              color="faded"
              variant="text"
            ></v-btn>
          </template>
        </v-tooltip>

        <!-- <v-tooltip text="Add a template to your post" location="bottom">
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              @click="selectMode('template')"
              icon="mdi-image-edit"
              color="faded"
              variant="text"
            ></v-btn>
          </template>
        </v-tooltip> -->

        <!-- <v-tooltip text="Add a PDF to your post" location="bottom">
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              @click="selectMode('pdf')"
              icon="mdi-file-pdf-box"
              color="faded"
              variant="text"
            ></v-btn>
          </template>
        </v-tooltip> -->

        <!-- <v-tooltip text="Add a carousel to your post" location="bottom">
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              @click="selectMode('carousel')"
              icon="mdi-view-carousel-outline"
              color="faded"
              variant="text"
            ></v-btn>
          </template>
        </v-tooltip> -->
      </div>

      <div
        v-else-if="mode === 'template'"
        style="width: 100%"
        class="pa-4"
        key="5"
      >
        <ImageBuilder />
      </div>

      <div
        v-else-if="mode === 'carousel'"
        style="width: 100%; height: 100%"
        class="d-flex flex-column"
        key="4"
      >
        <div class="d-flex align-center pa-2">
          <v-btn
            icon="mdi-delete-outline"
            color="faded"
            variant="text"
            size="small"
            @click="
              $store.commit('setPostCarousel', []);
              $store.commit('setPostMedia', []);
            "
          ></v-btn>
          <v-spacer></v-spacer>
          <span
            v-if="carouselSlides.length > 0"
            class="text-caption text-faded"
          >
            {{ currentSlide + 1 }} / {{ carouselSlides.length }}
          </span>
        </div>

        <div
          v-if="carouselSlides.length > 0"
          ref="slideContainer"
          style="flex: 1; position: relative; overflow: hidden; min-height: 0"
          class="d-flex align-center justify-center"
        >
          <v-btn
            icon="mdi-chevron-left"
            variant="text"
            color="faded"
            size="small"
            :disabled="currentSlide === 0"
            @click="currentSlide--"
            style="position: absolute; left: 4px; z-index: 1"
          ></v-btn>

          <div
            :style="{
              width: slideWidth + 'px',
              height: slideHeight + 'px',
              overflow: 'hidden',
              borderRadius: '8px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
            }"
          >
            <iframe
              :srcdoc="carouselSlides[currentSlide].slide_html"
              :style="{
                width: '1080px',
                height: '1350px',
                transform: 'scale(' + slideScale + ')',
                transformOrigin: 'top left',
                border: 'none',
                pointerEvents: 'none',
              }"
              sandbox="allow-same-origin"
            ></iframe>
          </div>

          <v-btn
            icon="mdi-chevron-right"
            variant="text"
            color="faded"
            size="small"
            :disabled="currentSlide >= carouselSlides.length - 1"
            @click="currentSlide++"
            style="position: absolute; right: 4px; z-index: 1"
          ></v-btn>
        </div>

        <div
          v-if="carouselSlides.length > 1"
          class="d-flex align-center justify-center pa-2"
          style="gap: 4px; overflow-x: auto"
        >
          <div
            v-for="(slide, i) in carouselSlides"
            :key="i"
            @click="currentSlide = i"
            :style="{
              width: '40px',
              height: '50px',
              borderRadius: '4px',
              overflow: 'hidden',
              cursor: 'pointer',
              border:
                currentSlide === i
                  ? '2px solid rgb(var(--v-theme-primary))'
                  : '1px solid rgba(255,255,255,0.1)',
              opacity: currentSlide === i ? 1 : 0.6,
              flexShrink: 0,
            }"
          >
            <iframe
              :srcdoc="slide.slide_html"
              style="
                width: 1080px;
                height: 1350px;
                transform: scale(0.037);
                transform-origin: top left;
                border: none;
                pointer-events: none;
              "
            ></iframe>
          </div>
        </div>
      </div>

      <div v-else-if="mode === 'link'" style="width: 100%" class="pa-4" key="2">
        <v-btn
          icon="mdi-arrow-left"
          color="faded"
          variant="text"
          @click="selectMode(null)"
        ></v-btn>
        <v-text-field
          label="Paste a link to add website"
          placeholder="www.example.com"
          variant="solo"
          flat
          v-model="link"
          ref="linkInput"
          hide-details
          :disabled="preview_loading"
          width="100%"
          @keyup.enter="getPreview"
          autofocus
          bg-color="smokeDark"
          style="border-radius: 5px"
        >
          <template #append-inner>
            <v-btn
              :disabled="!link"
              :loading="preview_loading"
              icon="mdi-plus"
              color="faded"
              variant="text"
              @click.stop="getPreview"
            ></v-btn>
          </template>
        </v-text-field>
      </div>

      <div
        v-else-if="mode === 'image' || mode === 'pdf'"
        style="width: 100%; max-height: 100%"
        key="3"
      >
        <div class="pa-4 d-flex align-center">
          <v-btn
            icon="mdi-arrow-left"
            color="faded"
            variant="text"
            class="mr-2"
            @click="selectMode(null)"
          ></v-btn>
          <v-chip-group v-model="filter" multiple column>
            <v-chip size="small" filter value="image">Images</v-chip>
            <v-chip size="small" filter value="video">Videos</v-chip>
            <v-chip size="small" filter value="document">Documents</v-chip>

            <!-- <v-chip size="small" filter value="audio">Audio</v-chip>
            <v-chip size="small" filter value="other">Other</v-chip> -->
          </v-chip-group>
          <v-spacer></v-spacer>
          <UploadMedia :loading="uploading" @loading="uploading = $event" />
        </div>
        <div
          v-if="filteredMedia.length > 0"
          class="px-2"
          style="
            max-height: 430px;
            overflow-y: auto;
            gap: 5px;
            display: flex;
            flex-wrap: wrap;
          "
        >
          <div
            v-for="file in filteredMedia"
            :key="file.uid"
            style="width: 200px; height: 200px"
          >
            <v-card
              @click="selectFile(file)"
              flat
              v-if="file.type === 'image' || file.type === 'video'"
              style="width: 100%; height: 100%"
            >
              <v-img
                cover
                :src="file.thumbnail || file.src"
                width="100%"
                height="100%"
                style="position: relative"
              >
                <v-btn
                  variant="flat"
                  color="primary"
                  icon="mdi-video"
                  size="large"
                  v-if="file.type === 'video'"
                  style="
                    opacity: 0.8;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                  "
                >
                </v-btn>
              </v-img>
            </v-card>

            <v-card
              v-else-if="file.type === 'document' || file.extension === 'pdf'"
              @click="selectFile(file)"
              flat
              style="
                border-left: 1px solid #212427;
                border-right: 3px solid #212427;
                border-top: 1px solid #212427;
                border-bottom: 3px solid #212427;
                width: 100%;
                height: 100%;
              "
              color="smokeDark"
            >
              <div
                style="
                  height: 200px;
                  width: 200px;
                  overflow: auto;
                  position: relative;
                  border-radius: 6px;
                "
              >
                <VuePdfEmbed :source="file.src" />
              </div>
            </v-card>
          </div>
        </div>
        <div v-else class="d-flex align-center justify-center">
          <p class="text-caption text-center">No media found</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import { mapState } from "vuex";
// import CarouselBuilder from "../carousel/carouselBuilder.vue";
import ImageBuilder from "../imageBuilder/index.vue";
import UploadMedia from "@/components/media/UploadMedia.vue";
import VuePdfEmbed from "vue-pdf-embed";
export default {
  name: "MediaEditor",
  components: {
    // CarouselBuilder,
    ImageBuilder,
    UploadMedia,
    VuePdfEmbed,
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      generatingPDF: (state) => state.post.generatingPDF,
      media: (state) => state.media.media,
    }),
    carouselSlides() {
      const c = this.$store.state.post.carousel;
      if (c?.length > 0 && c[0]?.slide_html) {
        return c;
      }
      return [];
    },
    slideScale() {
      const padding = 80;
      const availW = this.containerWidth - padding;
      const availH = this.containerHeight - 16;
      const scaleW = availW / 1080;
      const scaleH = availH / 1350;
      return Math.min(scaleW, scaleH, 1);
    },
    slideWidth() {
      return Math.round(1080 * this.slideScale);
    },
    slideHeight() {
      return Math.round(1350 * this.slideScale);
    },
    filteredMedia() {
      return this.media.filter(
        (file) =>
          this.filter.includes(file.type) ||
          (this.filter.includes("document") && file.extension === "pdf"),
      );
    },
    postMedia: {
      get() {
        return this.$store.state.post.media;
      },
      set(val) {
        this.$store.commit("setPostMedia", val);
      },
    },
    mode: {
      get() {
        return this.$store.state.post.mode;
      },
      set(val) {
        this.$store.commit("setPostMode", val);
      },
    },
  },
  data() {
    return {
      link: "",
      preview_loading: false,
      filter: ["image", "video", "document", "pdf"],
      uploading: false,
      currentSlide: 0,
      containerWidth: 400,
      containerHeight: 500,
    };
  },
  watch: {
    carouselSlides(val) {
      if (val.length > 0) {
        this.$nextTick(() => this.updateSlideSize());
      }
    },
  },
  mounted() {
    this._resizeObserver = new ResizeObserver(() => this.updateSlideSize());
    this.$nextTick(() => {
      if (this.$refs.slideContainer) {
        this._resizeObserver.observe(this.$refs.slideContainer);
      }
    });
  },
  beforeUnmount() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
  },
  methods: {
    updateSlideSize() {
      const el = this.$refs.slideContainer;
      if (el) {
        this.containerWidth = el.clientWidth;
        this.containerHeight = el.clientHeight;
      }
    },
    selectMode(mode) {
      this.mode = mode;
      if (mode === "link") {
        this.filter = ["image", "video", "document"];
        this.$nextTick(() => {
          if (
            this.$refs.linkInput &&
            typeof this.$refs.linkInput.focus === "function"
          ) {
            this.$refs.linkInput.focus();
          }
        });
      } else if (mode === "image") {
        this.filter = ["image", "video", "document", "pdf"];
      } else {
        this.filter = ["image", "video", "document", "pdf"];
      }
    },
    async getPreview() {
      this.link_loading = true;
      let prefix = "https://";
      let link = this.link;
      if (this.link != "") {
        if (!link.includes("http")) {
          link = prefix.concat(this.link);
        }
        this.preview_loading = true;
        console.log("Getting link preview");
        const getPreview = httpsCallable(functions, "getLinkPreview");
        const res = await getPreview({
          url: link,
        });
        console.log(res.data);
        if (res.data.error) {
          this.$store.commit("setNotification", {
            show: true,
            text: "Something went wrong. Try another URL.",
            type: "error",
            icon: "",
          });
        } else {
          let result = res.data;
          this.$emit("preview", result);
        }

        this.preview_loading = false;
        this.link = "";
        this.link_loading = false;
      } else {
        this.link_loading = false;
        this.$store.commit("setNotification", {
          show: true,
          text: "Incorrect link",
          type: "error",
          icon: "",
        });
        this.link_loading = false;
      }
    },
    selectFile(file) {
      this.$emit("selectMedia", file);
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
